import React, { useState } from "react";
import { Row, Col, Tabs, Input, Table, Typography } from "antd";
import { SearchOutlined, CheckCircleOutlined } from "@ant-design/icons";
import type { ColumnsType } from "antd/es/table";
import { ShopData } from "../types";
import "./ParticipatingShops.css";

const { Title } = Typography;

const ParticipatingShops: React.FC = () => {
  const [activeTab, setActiveTab] = useState("active");
  const [searchText, setSearchText] = useState("");

  const shopData: ShopData[] = [
    {
      key: "1",
      shopName: "Trek Bicycles",
      pointOfContact: "Brett Ludwig",
      testAch: "8967924916",
      testAchDateSent: "02/14/2025",
      preferredPaymentMethod: "ACH",
      traceId: "777136829",
      batchNumber: "777136",
      dateCreated: "01/22/2025",
      dateEnrolled: "sampleemail@email.com",
      phone: "555 123 4321",
      address1: "42 Windmill Ln",
      city: "Portland",
      state: "OR",
      zip: "222222",
    },
    {
      key: "2",
      shopName: "Portland Bicycle Emoporium",
      pointOfContact: "Meghan Clark",
      testAch: "Pending",
      testAchDateSent: "02/14/2025",
      preferredPaymentMethod: "ACH",
      traceId: "896792563",
      batchNumber: "896792",
      dateCreated: "01/22/2025",
      dateEnrolled: "sampleemail@email.com",
      phone: "555 123 4321",
      address1: "1234 Sunshine Dr",
      city: "Portland",
      state: "OR",
      zip: "222222",
    },
    {
      key: "3",
      shopName: "Cyclepath",
      pointOfContact: "Garrett Dyer",
      testAch: "$500",
      testAchDateSent: "02/01/2025",
      preferredPaymentMethod: "ACH",
      traceId: "734895172",
      batchNumber: "777136",
      dateCreated: "01/21/2025",
      dateEnrolled: "sampleemail@email.com",
      phone: "555 123 4321",
      address1: "542 Aloma",
      city: "Portland",
      state: "OR",
      zip: "222222",
    },
    {
      key: "4",
      shopName: "Bike Farm",
      pointOfContact: "Riley Denton",
      testAch: "8967924916",
      testAchDateSent: "02/01/2025",
      preferredPaymentMethod: "Check",
      traceId: "734895172",
      batchNumber: "9NVjDQ",
      dateCreated: "01/21/2025",
      dateEnrolled: "sampleemail@email.com",
      phone: "555 123 4321",
      address1: "2 Aruba",
      address2: "56 C",
      city: "Portland",
      state: "OR",
      zip: "222222",
    },
    {
      key: "5",
      shopName: "Clever Cycles",
      pointOfContact: "Richard Wagner",
      testAch: "$500",
      testAchDateSent: "02/01/2025",
      preferredPaymentMethod: "ACH",
      traceId: "896792563",
      batchNumber: "777136",
      dateCreated: "01/21/2025",
      dateEnrolled: "sampleemail@email.com",
      phone: "555 123 4321",
      address1: "32485 Walter St",
      city: "Portland",
      state: "OR",
      zip: "222222",
    },
    {
      key: "6",
      shopName: "Sample Shop",
      pointOfContact: "Elizabeth Wingen",
      testAch: "8967924916",
      testAchDateSent: "02/01/2025",
      preferredPaymentMethod: "ACH",
      traceId: "734895172",
      batchNumber: "896792",
      dateCreated: "01/21/2025",
      dateEnrolled: "sampleemail@email.com",
      phone: "555 123 4321",
      address1: "3258 Oak",
      city: "Portland",
      state: "OR",
      zip: "222222",
    },
    {
      key: "7",
      shopName: "Cyclepath",
      pointOfContact: "Sara Shillman",
      testAch: "Pending",
      testAchDateSent: "01/27/2025",
      preferredPaymentMethod: "ACH",
      traceId: "896792563",
      batchNumber: "777136",
      dateCreated: "01/11/2025",
      dateEnrolled: "sampleemail@email.com",
      phone: "555 123 4321",
      address1: "2 Ridge Route",
      city: "Portland",
      state: "OR",
      zip: "222222",
    },
    {
      key: "8",
      shopName: "Bike Farm",
      pointOfContact: "Christian Diehl",
      testAch: "8967924916",
      testAchDateSent: "01/27/2025",
      preferredPaymentMethod: "ACH",
      traceId: "734895172",
      batchNumber: "777136",
      dateCreated: "01/11/2025",
      dateEnrolled: "sampleemail@email.com",
      phone: "555 123 4321",
      address1: "99443 Bloomington Ct",
      address2: "Suite 100",
      city: "Portland",
      state: "OR",
      zip: "222222",
    },
    {
      key: "9",
      shopName: "Sample Shop",
      pointOfContact: "Jose Viera",
      testAch: "Pending",
      testAchDateSent: "01/27/2025",
      preferredPaymentMethod: "Check",
      traceId: "734895172",
      batchNumber: "896792",
      dateCreated: "01/11/2025",
      dateEnrolled: "sampleemail@email.com",
      phone: "555 123 4321",
      address1: "56 Estrella",
      city: "Portland",
      state: "OR",
      zip: "222222",
    },
    {
      key: "10",
      shopName: "Sample Shop",
      pointOfContact: "Hollee Guthrie",
      testAch: "Pending",
      testAchDateSent: "01/27/2025",
      preferredPaymentMethod: "ACH",
      traceId: "734895172",
      batchNumber: "896792",
      dateCreated: "01/11/2025",
      dateEnrolled: "sampleemail@email.com",
      phone: "555 123 4321",
      address1: "52833 Adelanto",
      city: "Portland",
      state: "OR",
      zip: "222222",
    },
  ];

  const columns: ColumnsType<ShopData> = [
    {
      title: "Bike Shop Name",
      dataIndex: "shopName",
      key: "shopName",
      width: 200,
      fixed: "left",
    },
    {
      title: "Point of Contact",
      dataIndex: "pointOfContact",
      key: "pointOfContact",
      width: 180,
    },
    {
      title: "Test ACH",
      dataIndex: "testAch",
      key: "testAch",
      width: 120,
    },
    {
      title: "Test ACH Date Sent",
      dataIndex: "testAchDateSent",
      key: "testAchDateSent",
      width: 160,
    },
    {
      title: "Preferred Payment Method",
      dataIndex: "preferredPaymentMethod",
      key: "preferredPaymentMethod",
      width: 200,
    },
    {
      title: "Trace ID",
      dataIndex: "traceId",
      key: "traceId",
      width: 120,
    },
    {
      title: "Batch Number",
      dataIndex: "batchNumber",
      key: "batchNumber",
      width: 140,
    },
    {
      title: "Date Created",
      dataIndex: "dateCreated",
      key: "dateCreated",
      width: 130,
    },
    {
      title: "Date Enrolled",
      dataIndex: "dateEnrolled",
      key: "dateEnrolled",
      width: 180,
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
      width: 130,
    },
    {
      title: "Address 1",
      dataIndex: "address1",
      key: "address1",
      width: 160,
    },
    {
      title: "Address 2",
      dataIndex: "address2",
      key: "address2",
      width: 120,
      render: (text) => text || "",
    },
    {
      title: "City",
      dataIndex: "city",
      key: "city",
      width: 100,
    },
    {
      title: "State",
      dataIndex: "state",
      key: "state",
      width: 80,
    },
    {
      title: "Zip",
      dataIndex: "zip",
      key: "zip",
      width: 100,
    },
  ];

  const tabItems = [
    {
      key: "active",
      label: (
        <div className="tab-item active-tab">
          <CheckCircleOutlined />
          <span>Active Shops</span>
        </div>
      ),
    },
    {
      key: "pending",
      label: "Pending Shop Applications",
    },
    {
      key: "inactive",
      label: "Inactive",
    },
    {
      key: "all",
      label: "All Shops",
    },
  ];

  return (
    <div className="participating-shops">
      {/* Page Header */}
      <Row align="middle" gutter={20} className="page-header">
        <Col>
          <div className="participating-shops-icon">
            <img
              src="/images/participating-shops-icon.png"
              alt="Participating Shops"
              style={{
                width: "30px",
                height: "27px",
              }}
            />
          </div>
        </Col>
        <Col>
          <Title level={2} className="page-title">
            Participating Shops
          </Title>
        </Col>
      </Row>

      {/* Tab Navigation */}
      <div className="tab-navigation">
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          items={tabItems}
          className="shop-tabs"
        />
      </div>

      {/* Action Bar */}
      <Row justify="space-between" align="middle" className="action-bar">
        <Col>
          <span className="shop-count">31 Active Participating Shops</span>
        </Col>
        <Col>
          <div className="search-container">
            <Input
              placeholder="Search"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              className="search-input"
              suffix={<SearchOutlined className="search-icon" />}
            />
          </div>
        </Col>
      </Row>

      {/* Data Table */}
      <div className="table-container">
        <Table
          columns={columns}
          dataSource={shopData}
          scroll={{ x: 2000, y: 560 }}
          pagination={{
            current: 1,
            pageSize: 10,
            total: shopData.length,
            showSizeChanger: false,
            className: "custom-pagination",
          }}
          className="shops-table"
          size="middle"
        />
      </div>
    </div>
  );
};

export default ParticipatingShops;
